// // src/services/Auth.js
// import AuthenticationContext from 'adal-angular'

// // We use this to enable logging in the adal library. When you're building for production, you should know that it's best to disable the logging.
// window.Logging.log = function(message) {
//   console.log(message); // this enables logging to the console
// }
// window.Logging.level = 2 // 0 = only error, 1 = up to warnings, 2 = up to info, 3 = up to verbose

// // Initialize the authentication
// export default new AuthenticationContext(AdalConfig)
import * as msal from "@azure/msal-browser"

const msalConfig: msal.Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ADAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ADAL_TENANT}`,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  },
  system: {
    loadFrameTimeout: 30000
  }
}

export const accessTokenRequest: msal.RedirectRequest = {
  scopes: [process.env.REACT_APP_ADAL_API_SCOPE]
}

export default new msal.PublicClientApplication(msalConfig);




// WEBPACK FOOTER //
// ./src/services/Auth.js